// Mock data for habita.co - Colombian real estate platform

export const CITIES = [
  'Bogotá', 'Medellín', 'Cali', 'Cartagena', 'Barranquilla',
  'Bucaramanga', 'Pereira', 'Santa Marta', 'Manizales', 'Cúcuta',
  'Villavicencio', 'Ibagué', 'Armenia', 'Pasto', 'Neiva'
];

export const NEIGHBORHOODS = {
  'Bogotá': ['Chapinero', 'Usaquén', 'Chicó', 'Rosales', 'Cedritos', 'Salitre', 'Suba', 'Teusaquillo'],
  'Medellín': ['El Poblado', 'Laureles', 'Envigado', 'Belén', 'Sabaneta', 'La Estrella'],
  'Cali': ['Granada', 'San Fernando', 'Ciudad Jardín', 'Pance', 'Norte'],
  'Cartagena': ['Bocagrande', 'Castillogrande', 'Manga', 'Crespo', 'Centro Histórico'],
  'Barranquilla': ['Alto Prado', 'Riomar', 'El Prado', 'Villa Country', 'Las Flores']
};

export const PROPERTY_TYPES = [
  { value: 'apartamento', label: 'Apartamento' },
  { value: 'casa', label: 'Casa' },
  { value: 'casa-campestre', label: 'Casa campestre' },
  { value: 'apartaestudio', label: 'Apartaestudio' },
  { value: 'finca', label: 'Finca' },
  { value: 'lote', label: 'Lote' },
  { value: 'oficina', label: 'Oficina' },
  { value: 'local', label: 'Local comercial' },
  { value: 'bodega', label: 'Bodega' }
];

export const formatCOP = (value) => {
  if (!value) return '$ 0';
  return '$ ' + Number(value).toLocaleString('es-CO');
};

/**
 * Compact COP price for map markers / cards. Examples:
 *   320_000_000  → '$320M'
 *   1_200_000_000 → '$1.200M'
 *   2_500_000    → '$2,5M/mes' (when operation === 'arriendo' shorthand)
 *   850_000      → '$850k'
 */
export const formatShortPrice = (value, operation = 'venta') => {
  const v = Number(value) || 0;
  let out;
  if (v >= 1_000_000_000) {
    const n = v / 1_000_000;
    out = '$' + (Number.isInteger(n) ? n.toLocaleString('es-CO') : n.toFixed(0).toLocaleString('es-CO')) + 'M';
  } else if (v >= 1_000_000) {
    const n = v / 1_000_000;
    out = '$' + (Number.isInteger(n) ? n : Math.round(n * 10) / 10).toLocaleString('es-CO') + 'M';
  } else if (v >= 1_000) {
    out = '$' + Math.round(v / 1_000).toLocaleString('es-CO') + 'k';
  } else {
    out = '$' + v;
  }
  return operation === 'arriendo' ? `${out}/mes` : out;
};

const IMG = {
  apt1: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc5NDIwMjU4fDA&ixlib=rb-4.1.0&q=85',
  apt2: 'https://images.unsplash.com/photo-1653972233229-1b8c042d6d8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc5NDIwMjU4fDA&ixlib=rb-4.1.0&q=85',
  apt3: 'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc5NDIwMjU4fDA&ixlib=rb-4.1.0&q=85',
  apt4: 'https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc5NDIwMjU4fDA&ixlib=rb-4.1.0&q=85',
  apt5: 'https://images.pexels.com/photos/27075286/pexels-photo-27075286.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  apt6: 'https://images.pexels.com/photos/33230969/pexels-photo-33230969.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  house1: 'https://images.unsplash.com/photo-1505843513577-22bb7d21e455?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3VzZXxlbnwwfHx8fDE3Nzk0MjAyNTh8MA&ixlib=rb-4.1.0&q=85',
  house2: 'https://images.unsplash.com/photo-1706808849780-7a04fbac83ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob3VzZXxlbnwwfHx8fDE3Nzk0MjAyNTh8MA&ixlib=rb-4.1.0&q=85',
  house3: 'https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3VzZXxlbnwwfHx8fDE3Nzk0MjAyNTh8MA&ixlib=rb-4.1.0&q=85',
  house4: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3VzZXxlbnwwfHx8fDE3Nzk0MjAyNTh8MA&ixlib=rb-4.1.0&q=85',
  liv1: 'https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxwcm9wZXJ0eSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTQyMDI1OHww&ixlib=rb-4.1.0&q=85',
  liv2: 'https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxwcm9wZXJ0eSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTQyMDI1OHww&ixlib=rb-4.1.0&q=85',
  liv3: 'https://images.unsplash.com/photo-1593696140826-c58b021acf8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxwcm9wZXJ0eSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTQyMDI1OHww&ixlib=rb-4.1.0&q=85',
  liv4: 'https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxwcm9wZXJ0eSUyMGludGVyaW9yfGVufDB8fHx8MTc3OTQyMDI1OHww&ixlib=rb-4.1.0&q=85',
  beach1: 'https://images.unsplash.com/photo-1739140019682-05bd100b5a5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxiZWFjaGZyb250JTIwcHJvcGVydHl8ZW58MHx8fHwxNzc5NDIwMjY3fDA&ixlib=rb-4.1.0&q=85',
  beach2: 'https://images.unsplash.com/photo-1707075108813-edefd7b3308d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxiZWFjaGZyb250JTIwcHJvcGVydHl8ZW58MHx8fHwxNzc5NDIwMjY3fDA&ixlib=rb-4.1.0&q=85',
  beach3: 'https://images.pexels.com/photos/15298798/pexels-photo-15298798.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  bed1: 'https://images.unsplash.com/photo-1562438668-bcf0ca6578f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBiZWRyb29tfGVufDB8fHx8MTc3OTQyMDI2N3ww&ixlib=rb-4.1.0&q=85',
  bed2: 'https://images.unsplash.com/photo-1586105251261-72a756497a11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBiZWRyb29tfGVufDB8fHx8MTc3OTQyMDI2N3ww&ixlib=rb-4.1.0&q=85',
  bed3: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiZWRyb29tfGVufDB8fHx8MTc3OTQyMDI2N3ww&ixlib=rb-4.1.0&q=85',
  bed4: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiZWRyb29tfGVufDB8fHx8MTc3OTQyMDI2N3ww&ixlib=rb-4.1.0&q=85',
  bed5: 'https://images.pexels.com/photos/34754004/pexels-photo-34754004.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  bed6: 'https://images.pexels.com/photos/32177992/pexels-photo-32177992.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  kit1: 'https://images.unsplash.com/photo-1617228069096-4638a7ffc906?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc3OTQyMDI2N3ww&ixlib=rb-4.1.0&q=85'
};

// Note: agent records come from the backend (`/api/properties/*` returns `agent`
// attached to each property). The frontend never relies on a local agent list.

export const PROPERTIES = [
  {
    id: 'p1', operation: 'venta', type: 'apartamento', price: 850000000,
    title: 'Apartamento moderno en El Poblado con vista panorámica',
    address: 'Carrera 43A #7-30, El Poblado',
    city: 'Medellín', neighborhood: 'El Poblado',
    beds: 3, baths: 2, parking: 2, area: 145, stratum: 6, year: 2021,
    images: [IMG.apt1, IMG.liv1, IMG.bed1, IMG.kit1, IMG.apt3],
    description: 'Espectacular apartamento en el corazón de El Poblado con acabados de lujo, ventanales de piso a techo, cocina integral en madera y mármol, y vista panorámica a la ciudad. Edificio con piscina, gimnasio, salón social y portería 24/7.',
    features: ['Piscina', 'Gimnasio', 'Salón social', 'Portería 24/7', 'Aire acondicionado', 'Balcón', 'Ascensor'],
    agentId: 'a1', lat: 6.2087, lng: -75.5670,
    inspections: [
      { date: '2025-07-19', time: '10:00 AM - 10:30 AM' },
      { date: '2025-07-19', time: '11:00 AM - 11:30 AM' },
      { date: '2025-07-22', time: '04:00 PM - 04:30 PM' }
    ],
    posted: '2025-07-08', featured: true
  },
  {
    id: 'p2', operation: 'venta', type: 'casa', price: 1450000000,
    title: 'Casa campestre con piscina en Llanogrande',
    address: 'Vereda La Mosca, Vía Llanogrande',
    city: 'Medellín', neighborhood: 'Rionegro',
    beds: 5, baths: 4, parking: 4, area: 420, stratum: 6, year: 2019,
    images: [IMG.house1, IMG.house2, IMG.liv2, IMG.bed2],
    description: 'Hermosa casa campestre con amplios jardines, piscina climatizada, BBQ y zona social al aire libre. Ideal para descanso familiar con privacidad total.',
    features: ['Piscina', 'Jardín', 'BBQ', 'Chimenea', 'Estudio', 'Cuarto de servicio'],
    agentId: 'a6', lat: 6.1469, lng: -75.4244,
    inspections: [
      { date: '2025-07-20', time: '11:00 AM - 11:45 AM' },
      { date: '2025-07-23', time: '02:00 PM - 02:45 PM' }
    ],
    posted: '2025-07-05', featured: true
  },
  {
    id: 'p3', operation: 'arriendo', type: 'apartamento', price: 3200000,
    title: 'Apartamento amoblado en Chicó Norte',
    address: 'Calle 96 #15-22, Chicó',
    city: 'Bogotá', neighborhood: 'Chicó',
    beds: 2, baths: 2, parking: 1, area: 95, stratum: 6, year: 2018,
    images: [IMG.apt2, IMG.liv3, IMG.bed3],
    description: 'Apartamento completamente amoblado y equipado en una de las zonas más exclusivas de Bogotá. A pocos pasos de restaurantes y centros comerciales.',
    features: ['Amoblado', 'Gimnasio', 'Portería 24/7', 'Calefacción', 'Internet incluido'],
    agentId: 'a5', lat: 4.6826, lng: -74.0466,
    inspections: [
      { date: '2025-07-18', time: '03:00 PM - 03:30 PM' },
      { date: '2025-07-21', time: '10:00 AM - 10:30 AM' }
    ],
    posted: '2025-07-10', featured: true
  },
  {
    id: 'p4', operation: 'venta', type: 'apartamento', price: 620000000,
    title: 'Apartamento frente al mar en Bocagrande',
    address: 'Avenida San Martín #5-94, Bocagrande',
    city: 'Cartagena', neighborhood: 'Bocagrande',
    beds: 3, baths: 3, parking: 1, area: 130, stratum: 6, year: 2020,
    images: [IMG.beach1, IMG.beach2, IMG.liv4, IMG.bed4],
    description: 'Increíble apartamento frente al mar Caribe con vistas espectaculares al atardecer. Acceso directo a la playa y zona exclusiva.',
    features: ['Vista al mar', 'Piscina', 'Acceso a playa', 'Aire acondicionado', 'Balcón'],
    agentId: 'a4', lat: 10.3997, lng: -75.5505,
    inspections: [
      { date: '2025-07-19', time: '09:00 AM - 09:45 AM' }
    ],
    posted: '2025-07-12', featured: true
  },
  {
    id: 'p5', operation: 'venta', type: 'casa', price: 980000000,
    title: 'Casa moderna en Ciudad Jardín',
    address: 'Carrera 105 #16-50, Ciudad Jardín',
    city: 'Cali', neighborhood: 'Ciudad Jardín',
    beds: 4, baths: 3, parking: 2, area: 280, stratum: 6, year: 2022,
    images: [IMG.house3, IMG.house4, IMG.liv1, IMG.bed5],
    description: 'Casa de diseño contemporáneo en conjunto cerrado, con amplias áreas sociales, jardín interior y acabados premium.',
    features: ['Conjunto cerrado', 'Jardín', 'Estudio', 'Cuarto de servicio', 'Gas natural'],
    agentId: 'a2', lat: 3.3756, lng: -76.5347,
    inspections: [
      { date: '2025-07-20', time: '10:00 AM - 10:45 AM' },
      { date: '2025-07-24', time: '04:00 PM - 04:45 PM' }
    ],
    posted: '2025-07-06', featured: false
  },
  {
    id: 'p6', operation: 'arriendo', type: 'apartamento', price: 2400000,
    title: 'Apartaestudio en Laureles',
    address: 'Circular 4 #70-15, Laureles',
    city: 'Medellín', neighborhood: 'Laureles',
    beds: 1, baths: 1, parking: 1, area: 55, stratum: 5, year: 2017,
    images: [IMG.apt4, IMG.liv2, IMG.bed6],
    description: 'Apartaestudio ideal para profesionales, completamente equipado en zona tranquila y arborizada.',
    features: ['Amoblado', 'Internet incluido', 'Portería', 'Ascensor'],
    agentId: 'a6', lat: 6.2466, lng: -75.5895,
    inspections: [
      { date: '2025-07-18', time: '02:00 PM - 02:30 PM' }
    ],
    posted: '2025-07-11', featured: false
  },
  {
    id: 'p7', operation: 'venta', type: 'apartamento', price: 1180000000,
    title: 'Penthouse de lujo en Usaquén',
    address: 'Calle 117 #6A-35, Usaquén',
    city: 'Bogotá', neighborhood: 'Usaquén',
    beds: 4, baths: 4, parking: 3, area: 220, stratum: 6, year: 2023,
    images: [IMG.apt5, IMG.apt6, IMG.liv3, IMG.bed1, IMG.kit1],
    description: 'Penthouse de doble altura con terraza privada de 80m², jacuzzi, cocina abierta y vista 360° a los cerros orientales.',
    features: ['Terraza privada', 'Jacuzzi', 'Doble altura', 'Chimenea', 'Domótica', 'Vista a cerros'],
    agentId: 'a3', lat: 4.6962, lng: -74.0307,
    inspections: [
      { date: '2025-07-19', time: '11:00 AM - 11:45 AM' },
      { date: '2025-07-22', time: '03:00 PM - 03:45 PM' }
    ],
    posted: '2025-07-09', featured: true
  },
  {
    id: 'p8', operation: 'arriendo', type: 'casa', price: 5800000,
    title: 'Casa en Alto Prado, Barranquilla',
    address: 'Carrera 56 #80-42, Alto Prado',
    city: 'Barranquilla', neighborhood: 'Alto Prado',
    beds: 4, baths: 3, parking: 2, area: 240, stratum: 6, year: 2016,
    images: [IMG.house2, IMG.liv4, IMG.bed2],
    description: 'Casa amplia con patio, BBQ y zona de juegos en uno de los barrios más tradicionales de Barranquilla.',
    features: ['Patio', 'BBQ', 'Aire acondicionado', 'Cuarto de servicio'],
    agentId: 'a4', lat: 11.0041, lng: -74.8070,
    inspections: [
      { date: '2025-07-21', time: '09:00 AM - 09:45 AM' }
    ],
    posted: '2025-07-07', featured: false
  },
  {
    id: 'p9', operation: 'venta', type: 'finca', price: 2100000000,
    title: 'Finca con lago en Llanogrande',
    address: 'Km 8 vía Llanogrande',
    city: 'Medellín', neighborhood: 'Rionegro',
    beds: 6, baths: 5, parking: 6, area: 850, stratum: 6, year: 2015,
    images: [IMG.house1, IMG.house4, IMG.liv1, IMG.bed3],
    description: 'Espectacular finca con lago propio, caballerizas, casa principal, casa de huéspedes y 8.000m² de jardines.',
    features: ['Lago', 'Caballerizas', 'Casa de huéspedes', 'BBQ', 'Cancha de tenis', 'Helipuerto'],
    agentId: 'a6', lat: 6.1469, lng: -75.4244,
    inspections: [
      { date: '2025-07-20', time: '10:00 AM - 11:00 AM' }
    ],
    posted: '2025-07-04', featured: true
  },
  {
    id: 'p10', operation: 'venta', type: 'apartamento', price: 480000000,
    title: 'Apartamento en Salitre con balcón',
    address: 'Avenida La Esperanza #69-30',
    city: 'Bogotá', neighborhood: 'Salitre',
    beds: 3, baths: 2, parking: 1, area: 105, stratum: 5, year: 2019,
    images: [IMG.apt3, IMG.liv2, IMG.bed4],
    description: 'Apartamento luminoso en el sector del Salitre, cerca a centros comerciales y al Parque Simón Bolívar.',
    features: ['Balcón', 'Gimnasio', 'Portería 24/7', 'Salón social'],
    agentId: 'a5', lat: 4.6586, lng: -74.1006,
    inspections: [
      { date: '2025-07-19', time: '02:00 PM - 02:30 PM' },
      { date: '2025-07-23', time: '11:00 AM - 11:30 AM' }
    ],
    posted: '2025-07-10', featured: false
  },
  {
    id: 'p11', operation: 'arriendo', type: 'apartamento', price: 4500000,
    title: 'Apartamento amoblado vista al mar en Castillogrande',
    address: 'Carrera 6 #5-90, Castillogrande',
    city: 'Cartagena', neighborhood: 'Castillogrande',
    beds: 2, baths: 2, parking: 1, area: 100, stratum: 6, year: 2020,
    images: [IMG.beach2, IMG.beach3, IMG.liv4, IMG.bed5],
    description: 'Apartamento totalmente amoblado con vista privilegiada a la bahía de Cartagena.',
    features: ['Amoblado', 'Vista al mar', 'Piscina', 'Gimnasio', 'Aire acondicionado'],
    agentId: 'a4', lat: 10.3997, lng: -75.5505,
    inspections: [
      { date: '2025-07-19', time: '04:00 PM - 04:30 PM' }
    ],
    posted: '2025-07-11', featured: false
  },
  {
    id: 'p12', operation: 'venta', type: 'casa', price: 720000000,
    title: 'Casa en conjunto cerrado en Envigado',
    address: 'Calle 38 Sur #28-10, Envigado',
    city: 'Medellín', neighborhood: 'Envigado',
    beds: 3, baths: 3, parking: 2, area: 180, stratum: 5, year: 2021,
    images: [IMG.house3, IMG.liv3, IMG.bed6],
    description: 'Casa de tres niveles en conjunto cerrado con piscina, gimnasio y zona BBQ comunal.',
    features: ['Conjunto cerrado', 'Piscina comunal', 'Gimnasio', 'Patio', 'Estudio'],
    agentId: 'a6', lat: 6.1701, lng: -75.5901,
    inspections: [
      { date: '2025-07-20', time: '03:00 PM - 03:30 PM' }
    ],
    posted: '2025-07-08', featured: false
  }
];

export const POPULAR_AREAS = [
  { city: 'Bogotá', count: 4892, image: IMG.apt1 },
  { city: 'Medellín', count: 3721, image: IMG.house1 },
  { city: 'Cartagena', count: 1864, image: IMG.beach1 },
  { city: 'Cali', count: 2103, image: IMG.house3 },
  { city: 'Barranquilla', count: 1456, image: IMG.apt2 },
  { city: 'Santa Marta', count: 987, image: IMG.beach2 }
];
